
import React, { useState } from 'react';
import { XMarkIcon, SpinnerIcon, TrashIcon } from '../../Icons';

export const SoftDeleteModal: React.FC<{ isOpen: boolean; onClose: () => void; onConfirm: (nombre: string, razon: string) => Promise<boolean>; isDeleting: boolean; code: string; }> = ({ isOpen, onClose, onConfirm, isDeleting, code }) => {
    const [nombre, setNombre] = useState('');
    const [razon, setRazon] = useState('');
    const [showConfirmStep, setShowConfirmStep] = useState(false);

    if (!isOpen) return null;

    if (showConfirmStep) {
        return (
            <div className="fixed inset-0 bg-gray-900/90 z-[200] flex items-center justify-center p-4 backdrop-blur-sm animate-fade-in">
                <div className="bg-white rounded-3xl shadow-2xl w-full max-w-md overflow-hidden p-8 border-t-4 border-amber-500">
                    <header className="flex justify-between items-center mb-6">
                        <h3 className="text-xl font-black uppercase text-amber-600 tracking-tighter">Confirmar Eliminación</h3>
                        <button onClick={() => setShowConfirmStep(false)}><XMarkIcon className="w-6 h-6 text-gray-500 hover:text-gray-700 transition-colors"/></button>
                    </header>
                    <p className="text-sm text-gray-750 mb-8 font-semibold leading-relaxed">
                        ¿Estás seguro de que quieres eliminar el inmueble? Recuerda que se eliminará también en el portal de ciencuadras
                    </p>
                    <div className="flex gap-3">
                        <button onClick={() => setShowConfirmStep(false)} className="flex-1 py-3 text-xs font-black uppercase text-gray-400 border border-gray-200 rounded-xl hover:bg-gray-50 transition-colors">Volver</button>
                        <button onClick={() => onConfirm(nombre, razon)} disabled={isDeleting} className="flex-[2] py-3 bg-red-600 hover:bg-red-700 transition-colors text-white rounded-xl text-xs font-black uppercase shadow-lg disabled:opacity-50 flex items-center justify-center gap-2">
                            {isDeleting ? <SpinnerIcon className="w-4 h-4"/> : <TrashIcon className="w-4 h-4"/>} Sí, eliminar
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="fixed inset-0 bg-gray-900/90 z-[200] flex items-center justify-center p-4 backdrop-blur-sm animate-fade-in">
            <div className="bg-white rounded-3xl shadow-2xl w-full max-w-md overflow-hidden p-8">
                <header className="flex justify-between items-center mb-6">
                    <h3 className="text-xl font-black uppercase text-red-600 tracking-tighter">Bajar Inmueble</h3>
                    <button onClick={onClose}><XMarkIcon className="w-6 h-6 text-gray-400"/></button>
                </header>
                <p className="text-sm text-gray-500 mb-6 font-medium">¿Estás seguro de retirar el inmueble <span className="font-black text-gray-800">{code}</span> del inventario?</p>
                <div className="space-y-4">
                    <input type="text" value={nombre} onChange={e => setNombre(e.target.value)} placeholder="Tu nombre completo" className="w-full p-3 border-2 border-gray-100 rounded-xl outline-none focus:border-red-500 text-sm font-bold" />
                    <textarea value={razon} onChange={e => setRazon(e.target.value)} placeholder="Motivo de la baja (ej: Vendido, Desistido...)" className="w-full p-3 border-2 border-gray-100 rounded-xl outline-none focus:border-red-500 text-sm font-bold h-24 resize-none" />
                </div>
                <div className="flex gap-3 mt-8">
                    <button onClick={onClose} className="flex-1 py-3 text-xs font-black uppercase text-gray-400">Cancelar</button>
                    <button onClick={() => setShowConfirmStep(true)} disabled={isDeleting || !nombre || !razon} className="flex-[2] py-3 bg-red-600 text-white rounded-xl text-xs font-black uppercase shadow-lg disabled:opacity-50 flex items-center justify-center gap-2">
                        {isDeleting ? <SpinnerIcon className="w-4 h-4"/> : <TrashIcon className="w-4 h-4"/>} Confirmar Baja
                    </button>
                </div>
            </div>
        </div>
    );
};
